export type InsideSlide = {
  title: string
  caption: string
  image: string
}

export const INSIDE_SLIDES: InsideSlide[] = [
  {
    title: 'Reading & Language',
    caption: 'Alphabet · Short & Long Vowels · Beginning Sounds',
    image:
      'https://cdn.magicpatterns.com/uploads/9dGyVCoS6PKzdizQ1y8ugA/ChatGPT-Image-19-ago-2026_-12_52_25-p.m..webp',
  },
  {
    title: 'Grammar & Writing',
    caption: 'Possessive Nouns · Compound Words · Prefixes · Suffixes',
    image:
      'https://cdn.magicpatterns.com/uploads/jaGCMKMhReirkPA5T9jAJ1/ChatGPT-Image-19-ago-2026_-12_53_30-p.m..webp',
  },
  {
    title: 'World & Geography',
    caption: 'Countries & Cultures · Landforms · Climate · Time Zones',
    image:
      'https://cdn.magicpatterns.com/uploads/wzpGNW45ZxH9jJveSuqLCk/ChatGPT-Image-19-ago-2026_-12_55_36-p.m..webp',
  },
  {
    title: 'Everyday Learning',
    caption: 'Good Citizen · Flags Of The World · Body Systems · Lifelong Learner',
    image:
      'https://cdn.magicpatterns.com/uploads/f5NwU11cuFBeVWFS6E2dQV/ChatGPT-Image-19-ago-2026_-12_56_18-p.m..webp',
  },
]
